import React, { useCallback, useState } from 'react';
import styledC from 'styled-components';
import theme from '@adsk/alloy-react-theme';
export let DividerPosition = /*#__PURE__*/function (DividerPosition) {
  DividerPosition["left"] = "left";
  DividerPosition["right"] = "right";
  return DividerPosition;
}({});
const StyledDividerContainer = styledC.div.withConfig({
  displayName: "ResizeDivider__StyledDividerContainer",
  componentId: "sc-1xv4no6-0"
})(["z-index:", ";height:", ";width:", ";position:absolute;top:0;left:", ";right:", ";"], theme.zIndex.panel, props => props.$vertical ? '100%' : '', props => props.$vertical ? "".concat(props.$width, "px") : '', props => props.$position === DividerPosition.left ? "-".concat(props.$width / 2, "px") : 'unset', props => props.$position === DividerPosition.right ? "-".concat(props.$width / 2, "px") : 'unset');
const StyledDividerHighlight = styledC.div.withConfig({
  displayName: "ResizeDivider__StyledDividerHighlight",
  componentId: "sc-1xv4no6-1"
})(["transition:background-color 0.1s ease-in-out;margin:auto;height:", ";"], props => props.$vertical ? '100%' : '');
const StyledDivider = styledC.div.withConfig({
  displayName: "ResizeDivider__StyledDivider",
  componentId: "sc-1xv4no6-2"
})(["height:", ";width:", ";cursor:", ";&:hover{", "{background:linear-gradient( to left,", ",", " 50%,", " );}}", "{background:", ";width:", ";", "}"], props => props.$vertical ? '100%' : '', props => props.$vertical ? "".concat(props.$affordanceWidth, "px") : '', props => props.$vertical ? 'ew-resize' : '', StyledDividerHighlight, theme.colors.adskBlue100, theme.colors.adskBlue500, theme.colors.adskBlue100, StyledDividerHighlight, props => {
  let firstColor = 'transparent';
  const lastColor = 'transparent';
  let direction = 'to left';
  if (props.$minReached || props.$maxReached) {
    firstColor = 'transparent 50%';
    if (props.$minReached) {
      direction = props.$position === DividerPosition.left ? 'to right' : 'to left';
    }
    if (props.$maxReached) {
      direction = props.$position === DividerPosition.left ? 'to left' : 'to right';
    }
  }
  return props.$dragging ? "linear-gradient(".concat(direction, ", ").concat(firstColor, ", ").concat(theme.colors.adskBlue500, " 50%, ").concat(lastColor, ")") : 'none';
}, props => {
  let width = props.$dragging ? props.$activeWidth : props.$hoverWidth;
  if (props.$dragging && (props.$minReached || props.$maxReached)) {
    width = props.$minMaxIndicatorWidth;
  }

  // ensure this never gets wider than resize affordance
  width = Math.min(width, props.$affordanceWidth);
  if (props.$vertical) {
    return "".concat(width, "px");
  } else {
    return '';
  }
}, props => props.$maxReached || props.$minReached ? 'transition: width 0.5s ease-in;' : '');
const StyledMouseCaptureLayer = styledC.div.withConfig({
  displayName: "ResizeDivider__StyledMouseCaptureLayer",
  componentId: "sc-1xv4no6-3"
})(["position:fixed;left:0;right:0;top:0;bottom:0;z-index:10000;user-select:none;pointer-events:", ";cursor:", ";"], props => props.$dragging ? 'all' : 'none', props => {
  if (props.$dragging) {
    if (props.$vertical) {
      return 'ew-resize';
    } else {
      return 'ns-resize';
    }
  }
  return '';
});
export const ResizeDivider = _ref => {
  let {
    onMouseDown,
    onMouseUp,
    onMouseMove,
    vertical = false,
    position = DividerPosition.left,
    affordanceWidth = 16,
    hoverWidth = 2,
    activeWidth = 6,
    minMaxIndicatorWidth = 14,
    minReached = false,
    maxReached = false
  } = _ref;
  const [dragging, setDragging] = useState(false);
  const handleMouseDown = useCallback(e => {
    setDragging(true);
    onMouseDown(e);
    e.preventDefault();
    e.stopPropagation();
  }, [onMouseDown]);
  const handleMouseUp = useCallback(e => {
    setDragging(false);
    onMouseUp(e);
    e.preventDefault();
    e.stopPropagation();
  }, [onMouseUp]);
  const handleMouseMove = useCallback(e => {
    onMouseMove(e);
    e.preventDefault();
    e.stopPropagation();
  }, [onMouseMove]);
  return /*#__PURE__*/React.createElement(StyledDividerContainer, {
    $vertical: vertical,
    $position: position,
    $width: affordanceWidth
  }, /*#__PURE__*/React.createElement(StyledDivider, {
    "data-testid": "resizeDivider",
    onMouseDown: handleMouseDown,
    $vertical: vertical,
    $dragging: dragging,
    $affordanceWidth: affordanceWidth,
    $hoverWidth: hoverWidth,
    $activeWidth: activeWidth,
    $minMaxIndicatorWidth: minMaxIndicatorWidth,
    $position: position,
    $minReached: minReached,
    $maxReached: maxReached
  }, /*#__PURE__*/React.createElement(StyledDividerHighlight, {
    $vertical: vertical
  })), /*#__PURE__*/React.createElement(StyledMouseCaptureLayer, {
    $vertical: vertical,
    $dragging: dragging,
    onMouseMove: handleMouseMove,
    onMouseUp: handleMouseUp
  }));
};
//# sourceMappingURL=ResizeDivider.js.map